import { ReactNode, useState } from 'react';
import { makeStyles } from '@fluentui/react-components';

import {
  LAYOUT_TRANSITION_DURATION,
  LAYOUT_TRANSITION_EASING,
  layoutTransition,
} from '@shared/constants/layoutTransition.constants';

const useStyles = makeStyles({
  // Mounting at full width squeezes the paper for a frame, so open at the container's own pace.
  enter: {
    overflow: 'hidden',
    animationName: { from: { width: '0px' } },
    animationDuration: LAYOUT_TRANSITION_DURATION,
    animationTimingFunction: LAYOUT_TRANSITION_EASING,
  },
});

type TProps = {
  widthPx: number;
  children: ReactNode;
};

// Stays mounted while sidebars swap inside it, so the widening plays only when the space opens.
const SidebarEnterTransition = ({ widthPx, children }: TProps) => {
  const [isEntering, setIsEntering] = useState(true);

  const classes = useStyles();
  return (
    <div
      className={isEntering ? classes.enter : undefined}
      style={{
        // An explicit width gives the keyframe a real value to grow to - it cannot animate to `auto`.
        width: `${widthPx}px`,
        // The sidebar keeps its width beside greedy content; `overflow: hidden` would let it be squeezed.
        flexShrink: 0,
        // Swapping to a wider sidebar resizes at the same pace as the page around it, instead of snapping.
        transition: isEntering ? undefined : layoutTransition('width'),
      }}
      // animationend bubbles, so an animation inside the sidebar would otherwise cut this one short.
      onAnimationEnd={(event) => event.target === event.currentTarget && setIsEntering(false)}
    >
      {children}
    </div>
  );
};

export default SidebarEnterTransition;
